import TabContext from "@mui/lab/TabContext"
import TabList from "@mui/lab/TabList"
import TabPanel from "@mui/lab/TabPanel"
import {
  Avatar,
  Box,
  Button,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  CardMedia,
  Container,
  Divider,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material"
import Tab from "@mui/material/Tab"
import * as React from "react"
import Layout from "../components/layout"
import Seo from "../components/seo"
import chatIcon from "../images/icons/chatIcon.svg"

import Will from "../images/will_marling.jpg"
import cleve from "../images/CliveVaz.png"
import aaron from "../images/AaronDix.png"

import RetailCasestudy1 from "../images/industries/retail/retailcasestudy1.jpg"
import RetailCasestudy2 from "../images/industries/retail/retailcasestudy2.jpg"
import RetailCasestudy3 from "../images/industries/retail/retailcasestudy3.jpg"

import Retailblog1 from "../images/industries/retail/retailblog1.jpg"
import Retailblog2 from "../images/industries/retail/retailblog2.jpg"
import Retailblog3 from "../images/industries/retail/retailblog3.jpg"

import ORSCapabilities1 from "../images/industries/retail/orscapabilities1.svg"
import ORSCapabilities2 from "../images/industries/retail/orscapabilities2.svg"
import ORSCapabilities3 from "../images/industries/retail/orscapabilities3.svg"
import ORSCapabilities4 from "../images/industries/retail/orscapabilities4.svg"

import ORSUsecase1 from "../images/industries/retail/orsusecase1.jpg"
import ORSUsecase2 from "../images/industries/retail/orsusecase2.jpg"
import ORSUsecase3 from "../images/industries/retail/orsusecase3.jpg"
import ORSUsecase4 from "../images/industries/retail/orsusecase4.jpg"

import ORSSolution1 from "../images/industries/retail/orssolution1.svg"
import ORSSolution2 from "../images/industries/retail/orssolution2.svg"
import ORSSolution3 from "../images/industries/retail/orssolution3.svg"
import ORSSolution4 from "../images/industries/retail/orssolution4.svg"
import ORSSolution5 from "../images/industries/retail/orssolution5.svg"

import * as allImages from "../utils/images"
import arrowRight from "../images/icons/arrowRight.svg"
import { style as styles } from "./homepage"
import { Button as ReactBtn } from "react-bootstrap"
import "swiper/css"
import "swiper/css/pagination"
import "swiper/css/navigation"
import { Swiper, SwiperSlide } from "swiper/react"
import { Autoplay, Navigation, Pagination } from "swiper"
import Enquiry from "../components/enqiry"

export const style = {
  mainWrapper: {
    paddingTop: "48px",
  },
  testimonialCard: {
    background: "#fff",
    padding: "25px",
    width: "33.33%",
    borderRadius: "20px",
    border: "2px solid #256aa3",
    "@media (max-width: 600px)": {
      width: "100%",
    },
  },
  wordingsBlock: {
    maxHeight: "8.5rem",
    marginBottom: 0,
    overflow: "auto",
    "&::-webkit-scrollbar": {
      width: "8px",
    },
    "&::-webkit-scrollbar-track": {
      background: "#f1f1f1",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#aaaaaa",
      borderRadius: "10px",
      border: "2px solid #f1f1f1",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: "#757575",
    },
    "@media (max-width: 600px)": {
      height: "7.2rem",
    },
  },
}

const OmnichannelEcommerceSolution = (props: any) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("md"))
  const [tabValue, setTabValue] = React.useState("1")

  const handleCasestudyTab = (
    event: React.SyntheticEvent,
    tabValue: string
  ) => {
    setTabValue(tabValue)
  }

  return (
    <Layout>
      <Seo
        title="Omnichannel Retail & Scalable E-commerce Solutions"
        description="Optimize your retail business with Invimatic’s scalable eCommerce solutions for seamless operations and enhanced customer experience."
      />

      <section className="newheroSection">
        <div className="industryBanner retailBanner">
          <Container maxWidth="xl" className="mainWrapper">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={10} lg={10}>
                <Stack
                  alignItems="flex-start"
                  sx={{ position: "relative", color: "#fff" }}
                  className="bannerHeading"
                >
                  <Typography
                    variant="body1"
                    fontSize={18}
                    fontWeight={600}
                    mt="50px"
                  >
                    Retail
                  </Typography>
                  <Typography
                    variant="h1"
                    fontSize={52}
                    fontWeight={600}
                    m={isMobile ? "0px 0px 15px" : "15px 0px"}
                  >
                    Comprehensive Omnichannel Retail Software Solutions for
                    Seamless Customer Journeys
                  </Typography>
                  <Typography variant="h6" fontSize={18} mb={4}>
                    Integrate Online, In-Store, and Mobile for Real-Time
                    Synchronization and Growth
                  </Typography>
                  <ReactBtn
                    href="/contact"
                    className="btn btn-primary commonBtn"
                  >
                    Let’s Talk
                  </ReactBtn>
                </Stack>
              </Grid>
            </Grid>
          </Container>
        </div>
      </section>

      <section
        className="summary-section"
        style={{ backgroundColor: "#FCFCFC" }}
      >
        <Stack
          alignItems="center"
          textAlign="center"
          sx={styles.heading}
          id="yourTargetElementId"
        >
          <Typography
            variant="h2"
            lineHeight="40px !important"
            className="sectHeading"
          >
            Overview
          </Typography>
          <Divider></Divider>
        </Stack>
        <Grid container p="40px 0px 0px">
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Box display="flex" gap={3} flexDirection="row">
              <div>
                <Typography color="#333333" fontSize="18px">
                  In the dynamic retail landscape, providing a seamless shopping
                  experience across all channels is crucial for success.
                  Invimatic leverages deep domain expertise and technical
                  capabilities to create custom-engineered solutions that bridge
                  digital and physical touchpoints. This allows retailers to
                  deliver consistent, high-quality interactions, whether
                  customers shop online, in-store, or via mobile platforms.
                </Typography>
                <Typography color="#333333" fontSize="18px" pt="24px">
                  Our approach goes beyond merely establishing a presence across
                  multiple channels; we focus on developing a fully integrated
                  system that unifies these experiences. With expertise in
                  building{" "}
                  <a
                    href="/ecommerce-development-services/"
                    className="interlinking"
                  >
                    e-commerce
                  </a>{" "}
                  platforms and integrating in-store technologies, we ensure
                  real-time synchronization of inventory, orders, and customer
                  data. This enables retailers to offer services like
                  click-and-collect, real-time stock updates, and personalized
                  promotions, enhancing customer satisfaction and operational
                  efficiency.
                </Typography>
                <Typography color="#333333" fontSize="18px" pt="24px">
                  By creating scalable and adaptable systems tailored to unique
                  business needs, we empower retailers to optimize operations
                  and respond swiftly to market changes. Partnering with
                  Invimatic means leveraging robust technology to effectively
                  manage inventory, streamline order processes, and deliver
                  exceptional customer experiences.
                </Typography>
              </div>
            </Box>
          </Grid>
        </Grid>
      </section>

      <section className="capabilities-section">
        <Stack
          alignItems="center"
          textAlign="center"
          sx={styles.heading}
          id="yourTargetElementId"
        >
          <Typography
            variant="h2"
            lineHeight="40px !important"
            className="sectHeading"
          >
            Capabilities
          </Typography>
          <Divider></Divider>
        </Stack>
        {isMobile ? (
          <Swiper
            className="capabilities-swiper"
            modules={[Autoplay, Navigation]}
            spaceBetween={14}
            loop={true}
            centeredSlides={true}
            autoplay={{ delay: 3000 }}
            navigation={true}
          >
            <SwiperSlide className="slideWidth">
              <Box
                sx={{
                  backgroundColor: "#fff",
                  pt: 6,
                }}
                display="flex"
                flexDirection="column"
                justifyContent="space-between"
              >
                <Card
                  className="capabilities-card"
                  sx={{
                    width: isMobile ? "100%" : "33.33%",
                  }}
                >
                  <CardMedia
                    component="img"
                    className="capabilities-image"
                    image={ORSCapabilities1}
                    alt="Custom Warehouse Management System (WMS) Development"
                    sx={{ objectPosition: "top", objectFit: "fill" }}
                  />
                  <CardContent sx={{ paddingLeft: "20px" }}>
                    <Box className="capabilities-card-content-box">
                      <Typography
                        fontSize={18}
                        fontWeight={700}
                        mb={1.5}
                        color="#333"
                        component="div"
                      >
                        Unified Commerce Platform Development
                      </Typography>
                      <Typography
                        variant="body2"
                        mb={0}
                        color="#333"
                        component="div"
                      >
                        We build unified commerce platforms that seamlessly
                        integrate online, in-store, and mobile channels,
                        ensuring streamlined operations and consistent customer
                        experiences, tailored to your unique business needs.
                      </Typography>
                    </Box>
                    <Typography
                      fontSize={16}
                      mb={0}
                      color="#333"
                      component="div"
                      className="blue-card"
                      minHeight="138px"
                    >
                      <ul>
                        <li>Multi-Channel Product Catalog Management</li>
                        <li>Integrated Order Processing</li>
                        <li>Consistent User Experience</li>
                      </ul>
                    </Typography>
                  </CardContent>
                </Card>
              </Box>
            </SwiperSlide>
            <SwiperSlide className="slideWidth">
              <Box
                sx={{
                  backgroundColor: "#fff",
                  pt: 6,
                }}
                display="flex"
                flexDirection="column"
                justifyContent="space-between"
              >
                <Card
                  className="capabilities-card"
                  sx={{
                    width: isMobile ? "100%" : "33.33%",
                  }}
                >
                  <CardMedia
                    component="img"
                    className="capabilities-image"
                    image={ORSCapabilities2}
                    alt="Mobile App Development"
                    sx={{ objectPosition: "top", objectFit: "fill" }}
                  />
                  <CardContent sx={{ paddingLeft: "20px" }}>
                    <Box className="capabilities-card-content-box">
                      <Typography
                        fontSize={18}
                        fontWeight={700}
                        mb={1.5}
                        color="#333"
                        component="div"
                      >
                        Real-Time Inventory Management
                      </Typography>
                      <Typography
                        variant="body2"
                        mb={0}
                        color="#333"
                        component="div"
                      >
                        We develop custom inventory management systems that
                        provide real-time stock-level visibility across sales
                        channels. These solutions address your specific business
                        challenges, enabling accurate inventory tracking and
                        optimized stock management.
                      </Typography>
                    </Box>
                    <Typography
                      mb={0}
                      color="#333"
                      component="div"
                      className="blue-card"
                      minHeight="138px"
                    >
                      <ul>
                        <li>Inventory Synchronization</li>
                        <li>Dynamic Stock Allocation</li>
                        <li>Omnichannel Fulfillment Options</li>
                      </ul>
                    </Typography>
                  </CardContent>
                </Card>
              </Box>
            </SwiperSlide>
            <SwiperSlide className="slideWidth">
              <Box
                sx={{
                  backgroundColor: "#fff",
                  pt: 6,
                }}
                display="flex"
                flexDirection="column"
                justifyContent="space-between"
              >
                <Card
                  className="capabilities-card"
                  sx={{
                    width: isMobile ? "100%" : "33.33%",
                  }}
                >
                  <CardMedia
                    component="img"
                    className="capabilities-image"
                    image={ORSCapabilities3}
                    alt="User-Centric Interface"
                    sx={{ objectPosition: "top", objectFit: "fill" }}
                  />
                  <CardContent sx={{ paddingLeft: "20px" }}>
                    <Box className="capabilities-card-content-box">
                      <Typography
                        fontSize={18}
                        fontWeight={700}
                        mb={1.5}
                        color="#333"
                        component="div"
                      >
                        Scalable E-Commerce Solutions
                      </Typography>
                      <Typography
                        variant="body2"
                        mb={0}
                        color="#333"
                        component="div"
                      >
                        Our team builds scalable ecommerce solutions for your
                        business model. We focus on creating secure,
                        high-performance platforms that handle complex product
                        catalogs and high traffic, ensuring a smooth shopping
                        experience.
                      </Typography>
                    </Box>
                    <Typography
                      fontSize={16}
                      mb={0}
                      color="#333"
                      component="div"
                      className="blue-card"
                      minHeight="138px"
                    >
                      <ul>
                        <li>Custom Checkout Flows</li>
                        <li>Third-Party Integration</li>
                        <li>Multi-Language and Multi-Currency Support</li>
                      </ul>
                    </Typography>
                  </CardContent>
                </Card>
              </Box>
            </SwiperSlide>
            <SwiperSlide className="slideWidth">
              <Box
                sx={{
                  backgroundColor: "#fff",
                  pt: 6,
                }}
                display="flex"
                flexDirection="column"
                justifyContent="space-between"
              >
                <Card
                  className="capabilities-card"
                  sx={{
                    width: isMobile ? "100%" : "33.33%",
                  }}
                >
                  <CardMedia
                    component="img"
                    className="capabilities-image"
                    image={ORSCapabilities4}
                    alt="Visualizations"
                    sx={{ objectPosition: "top", objectFit: "fill" }}
                  />
                  <CardContent sx={{ paddingLeft: "20px" }}>
                    <Box className="capabilities-card-content-box">
                      <Typography
                        fontSize={18}
                        fontWeight={700}
                        mb={1.5}
                        color="#333"
                        component="div"
                      >
                        Advanced DevSecOps for Retail
                      </Typography>
                      <Typography
                        variant="body2"
                        mb={0}
                        color="#333"
                        component="div"
                      >
                        {" "}
                        We implement vigorous DevSecOps practices, integrating
                        security into development and operations to ensure a
                        secure, efficient software lifecycle that aligns with
                        your business goals, delivering high performance and
                        reliability.
                      </Typography>
                    </Box>
                    <Typography
                      fontSize={16}
                      mb={0}
                      color="#333"
                      component="div"
                      className="blue-card"
                      minHeight="138px"
                    >
                      <ul>
                        <li>CI/CD Pipeline Integration</li>
                        <li>Secure Code Practices</li>
                        <li>Infrastructure as Code (IaC)</li>
                      </ul>
                    </Typography>
                  </CardContent>
                </Card>
              </Box>
            </SwiperSlide>
          </Swiper>
        ) : (
          <Swiper
            className="capabilities-swiper"
            modules={[Autoplay, Navigation]}
            spaceBetween={14}
            loop={true}
            centeredSlides={true}
            autoplay={{ delay: 3000 }}
            navigation={true}
          >
            <SwiperSlide className="slideWidth">
              <Box
                sx={{
                  backgroundColor: "#fff",
                  pt: 6,
                }}
                display="flex"
                flexDirection="row"
                justifyContent="space-between"
              >
                <Card
                  className="capabilities-card"
                  sx={{
                    width: isMobile ? "100%" : "33.33%",
                  }}
                >
                  <CardMedia
                    component="img"
                    className="capabilities-image"
                    image={ORSCapabilities1}
                    alt="Custom Warehouse Management System (WMS) Development"
                    sx={{ objectPosition: "top", objectFit: "fill" }}
                  />
                  <CardContent sx={{ paddingLeft: "20px" }}>
                    <Box className="capabilities-card-content-box">
                      <Typography
                        fontSize={18}
                        fontWeight={700}
                        mb={1.5}
                        color="#333"
                        component="div"
                      >
                        Unified Commerce Platform Development
                      </Typography>
                      <Typography
                        variant="body2"
                        mb={0}
                        color="#333"
                        component="div"
                      >
                        We build unified commerce platforms that seamlessly
                        integrate online, in-store, and mobile channels,
                        ensuring streamlined operations and consistent customer
                        experiences, tailored to your unique business needs.
                      </Typography>
                    </Box>
                    <Typography
                      fontSize={16}
                      mb={0}
                      color="#333"
                      component="div"
                      className="blue-card"
                      minHeight="138px"
                    >
                      <ul>
                        <li>Multi-Channel Product Catalog Management</li>
                        <li>Integrated Order Processing</li>
                        <li>Consistent User Experience</li>
                      </ul>
                    </Typography>
                  </CardContent>
                </Card>
                <Card
                  className="capabilities-card"
                  sx={{
                    width: isMobile ? "100%" : "33.33%",
                  }}
                >
                  <CardMedia
                    component="img"
                    className="capabilities-image"
                    image={ORSCapabilities2}
                    alt="Mobile App Development"
                    sx={{ objectPosition: "top", objectFit: "fill" }}
                  />
                  <CardContent sx={{ paddingLeft: "20px" }}>
                    <Box className="capabilities-card-content-box">
                      <Typography
                        fontSize={18}
                        fontWeight={700}
                        mb={1.5}
                        color="#333"
                        component="div"
                      >
                        Real-Time Inventory Management
                      </Typography>
                      <Typography
                        variant="body2"
                        mb={0}
                        color="#333"
                        component="div"
                      >
                        We develop custom inventory management systems that
                        provide real-time stock-level visibility across sales
                        channels. These solutions address your specific business
                        challenges, enabling accurate inventory tracking and
                        optimized stock management.
                      </Typography>
                    </Box>
                    <Typography
                      mb={0}
                      color="#333"
                      component="div"
                      className="blue-card"
                      minHeight="138px"
                    >
                      <ul>
                        <li>Inventory Synchronization</li>
                        <li>Dynamic Stock Allocation</li>
                        <li>Omnichannel Fulfillment Options</li>
                      </ul>
                    </Typography>
                  </CardContent>
                </Card>
                <Card
                  className="capabilities-card"
                  sx={{
                    width: isMobile ? "100%" : "33.33%",
                  }}
                >
                  <CardMedia
                    component="img"
                    className="capabilities-image"
                    image={ORSCapabilities3}
                    alt="User-Centric Interface"
                    sx={{ objectPosition: "top", objectFit: "fill" }}
                  />
                  <CardContent sx={{ paddingLeft: "20px" }}>
                    <Box className="capabilities-card-content-box">
                      <Typography
                        fontSize={18}
                        fontWeight={700}
                        mb={1.5}
                        color="#333"
                        component="div"
                      >
                        Scalable E-Commerce Solutions
                      </Typography>
                      <Typography
                        variant="body2"
                        mb={0}
                        color="#333"
                        component="div"
                      >
                        Our team builds scalable ecommerce solutions for your
                        business model. We focus on creating secure,
                        high-performance platforms that handle complex product
                        catalogs and high traffic, ensuring a smooth shopping
                        experience.
                      </Typography>
                    </Box>
                    <Typography
                      fontSize={16}
                      mb={0}
                      color="#333"
                      component="div"
                      className="blue-card"
                      minHeight="138px"
                    >
                      <ul>
                        <li>Custom Checkout Flows</li>
                        <li>Third-Party Integration</li>
                        <li>Multi-Language and Multi-Currency Support</li>
                      </ul>
                    </Typography>
                  </CardContent>
                </Card>
                <Card
                  className="capabilities-card"
                  sx={{
                    width: isMobile ? "100%" : "33.33%",
                  }}
                >
                  <CardMedia
                    component="img"
                    className="capabilities-image"
                    image={ORSCapabilities4}
                    alt="Visualizations"
                    sx={{ objectPosition: "top", objectFit: "fill" }}
                  />
                  <CardContent sx={{ paddingLeft: "20px" }}>
                    <Box className="capabilities-card-content-box">
                      <Typography
                        fontSize={18}
                        fontWeight={700}
                        mb={1.5}
                        color="#333"
                        component="div"
                      >
                        Advanced DevSecOps for Retail
                      </Typography>
                      <Typography
                        variant="body2"
                        mb={0}
                        color="#333"
                        component="div"
                      >
                        {" "}
                        We implement vigorous DevSecOps practices, integrating
                        security into development and operations to ensure a
                        secure, efficient software lifecycle that aligns with
                        your business goals, delivering high performance and
                        reliability.
                      </Typography>
                    </Box>
                    <Typography
                      fontSize={16}
                      mb={0}
                      color="#333"
                      component="div"
                      className="blue-card"
                      minHeight="138px"
                    >
                      <ul>
                        <li>CI/CD Pipeline Integration</li>
                        <li>Secure Code Practices</li>
                        <li>Infrastructure as Code (IaC)</li>
                      </ul>
                    </Typography>
                  </CardContent>
                </Card>
              </Box>
            </SwiperSlide>
            {/* <SwiperSlide className="slideWidth">
              <Box
                sx={{
                  backgroundColor: "#fff",
                  pt: 6,
                }}
                display="flex"
                flexDirection={isMobile ? "column" : "row"}
                justifyContent="space-between"
              >
                <Card
                  className="capabilities-card"
                  sx={{
                    width: isMobile ? "100%" : "33.33%",
                  }}
                >
                  <CardMedia
                    component="img"
                    className="capabilities-image"
                    image={warehouseOperationAutomation}
                    alt="End-to-End Warehouse Operation Automation"
                    sx={{ objectPosition: "top", objectFit: "fill" }}
                  />
                  <CardContent sx={{ paddingLeft: "20px" }}>
                    <Box className="capabilities-card-content-box">
                      <Typography
                        fontSize={18}
                        fontWeight={700}
                        mb={1.5}
                        color="#333"
                        component="div"
                      >
                        End-to-End Warehouse Operation Automation
                      </Typography>
                      <Typography
                        variant="body2"
                        mb={0}
                        color="#333"
                        component="div"
                      >
                        We transform your warehouse operations with
                        comprehensive automation solutions. We integrate
                        advanced technologies to streamline all aspects of
                        warehouse management, from inbound and outbound
                        processes to automated invoicing.
                      </Typography>
                    </Box>
                    <Typography
                      fontSize={16}
                      mb={0}
                      color="#333"
                      component="div"
                      className="blue-card"
                      minHeight="138px"
                    >
                      <ul>
                        <li>Labour Optimization</li>
                        <li>Yard Management</li>
                        <li>Real-Time Appointment & Booking Systems</li>
                        <li>Automated Invoicing</li>
                      </ul>
                    </Typography>
                  </CardContent>
                </Card>
              </Box>
            </SwiperSlide> */}
          </Swiper>
        )}
      </section>

      <section className="usecase-section">
        <Stack gap={6}>
          <Stack alignItems="center" sx={styles.heading}>
            <Typography
              color="rgb(255, 255, 255)"
              variant="h2"
              className="sectHeading"
            >
              Use Cases
            </Typography>
            <Divider></Divider>
          </Stack>
          <Grid
            container
            columnSpacing={isMobile ? 0 : 3}
            rowGap={2}
            direction={isMobile ? "column" : "row"}
          >
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <Stack
                direction={isMobile ? "column" : "row"}
                spacing={2}
                className="usecase-card"
              >
                <img
                  src={ORSUsecase1}
                  alt="E-commerce Fulfillment Optimization"
                  height="100%"
                />
                <Stack>
                  <Typography
                    variant="h5"
                    fontWeight={700}
                    fontSize={18}
                    mb={2}
                  >
                    Unified Customer Profiles and Order History
                  </Typography>
                  <Typography className="usecase-text">
                    We consolidate data from various sales channels, offering a
                    complete view of customer interactions and purchases. This
                    facilitates personalized marketing and consistent service
                    across both online and offline platforms.
                  </Typography>
                </Stack>
              </Stack>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <Stack
                direction={isMobile ? "column" : "row"}
                spacing={2}
                className="usecase-card"
              >
                <img
                  src={ORSUsecase2}
                  alt="Supply Chain Visibility and Control"
                  height="100%"
                />
                <Stack>
                  <Typography
                    variant="h5"
                    fontWeight={700}
                    fontSize={18}
                    mb={2}
                  >
                    Click-and-Collect and Ship-from-Store Capabilities
                  </Typography>
                  <Typography className="usecase-text">
                    By integrating inventory systems, we enable seamless BOPIS
                    and ship-from-store options. This improves customer
                    convenience, optimizes in-store stock, and reduces delivery
                    times, enhancing the overall shopping experience.
                  </Typography>
                </Stack>
              </Stack>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <Stack
                direction={isMobile ? "column" : "row"}
                spacing={2}
                className="usecase-card"
              >
                <img
                  src={ORSUsecase3}
                  alt="Seasonal Inventory Management"
                  height="100%"
                />
                <Stack>
                  <Typography
                    variant="h5"
                    fontWeight={700}
                    fontSize={18}
                    mb={2}
                  >
                    Real-Time Inventory Synchronization
                  </Typography>
                  <Typography className="usecase-text">
                    Our systems synchronize inventory in real time across all
                    channels, preventing stock discrepancies. It ensures
                    accurate product availability, supports better inventory
                    planning, and enhances customer satisfaction.
                  </Typography>
                </Stack>
              </Stack>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <Stack
                direction={isMobile ? "column" : "row"}
                spacing={2}
                className="usecase-card"
              >
                <img src={ORSUsecase4} alt="Reverse Logistics" height="100%" />
                <Stack>
                  <Typography
                    variant="h5"
                    fontWeight={700}
                    fontSize={18}
                    mb={2}
                  >
                    Seamless Returns Across Channels
                  </Typography>
                  <Typography className="usecase-text">
                    We develop solutions that streamline returns, allowing
                    customers to make returns across any channel. The
                    flexibility improves customer satisfaction and simplifies
                    reverse logistics, enhancing operational efficiency for
                    retailers.
                  </Typography>
                </Stack>
              </Stack>
            </Grid>
          </Grid>
        </Stack>
      </section>

      <section className="other-solutions-section">
        <Stack gap={isMobile ? 6 : 8}>
          <Stack alignItems="center" sx={styles.heading}>
            <Typography
              color="rgb(255, 255, 255)"
              variant="h2"
              className="sectHeading"
            >
              Other Solutions
            </Typography>
            <Divider></Divider>
          </Stack>
          <Stack spacing={4} direction={{ xs: "column", md: "row" }}>
            <a
              href="/ecommerce-development-serviIntegration/"
              className="other-solution-wrapper"
            >
              <img
                src={ORSSolution1}
                alt="Smart Hospitality
                Solutions"
                height="60px"
              />
              <Stack
                flexDirection="row"
                alignItems="center"
                justifyContent={isMobile ? "center" : "space-between"}
                className="other-solution-block"
              >
                <Typography fontSize={18} fontWeight={700}>
                  E-Commerce Development
                </Typography>
                <img
                  src={allImages.whiteArrow}
                  className="arrow"
                  width="30px"
                />
              </Stack>
            </a>
            <a
              href="/retail-inventory-management-solutions/"
              className="other-solution-wrapper"
            >
              <img src={ORSSolution2} alt="Manufacturing" height="60px" />
              <Stack
                flexDirection="row"
                alignItems="center"
                justifyContent={isMobile ? "center" : "space-between"}
                className="other-solution-block"
              >
                <Typography fontSize={18} fontWeight={700}>
                  Retail Inventory Management Solutions
                </Typography>
                <img
                  src={allImages.whiteArrow}
                  className="arrow"
                  width="30px"
                />
              </Stack>
            </a>
            <a
              href="/customer-engagement-solutions/"
              className="other-solution-wrapper"
            >
              <img src={ORSSolution3} alt="Manufacturing" height="60px" />
              <Stack
                flexDirection="row"
                alignItems="center"
                justifyContent={isMobile ? "center" : "space-between"}
                className="other-solution-block"
              >
                <Typography fontSize={18} fontWeight={700}>
                  Customer Experience Solutions
                </Typography>
                <img
                  src={allImages.whiteArrow}
                  className="arrow"
                  width="30px"
                />
              </Stack>
            </a>
            <a
              href="/point-of-sale-systems/"
              className="other-solution-wrapper"
            >
              <img src={ORSSolution4} alt="Manufacturing" height="60px" />
              <Stack
                flexDirection="row"
                alignItems="center"
                justifyContent={isMobile ? "center" : "space-between"}
                className="other-solution-block"
              >
                <Typography fontSize={18} fontWeight={700}>
                  Point of Sale (POS) Systems
                </Typography>
                <img
                  src={allImages.whiteArrow}
                  className="arrow"
                  width="30px"
                />
              </Stack>
            </a>
            <a
              href="/integrated-solutions-for-retailers/"
              className="other-solution-wrapper"
            >
              <img
                src={ORSSolution5}
                alt="Travel Management Solutions (TMS)"
                height="60px"
              />
              <Stack
                flexDirection="row"
                alignItems="center"
                justifyContent={isMobile ? "center" : "space-between"}
                className="other-solution-block"
              >
                <Typography fontSize={18} fontWeight={700}>
                  Integration Solutions
                </Typography>
                <img
                  src={allImages.whiteArrow}
                  className="arrow"
                  width="30px"
                />
              </Stack>
            </a>
          </Stack>
        </Stack>
      </section>

      <section>
        <Box className="casestudy-tabs-block">
          <Stack
            alignItems="center"
            textAlign="center"
            sx={styles.heading}
            id="yourTargetElementId"
          >
            <Typography
              variant="h2"
              className="sectHeading"
              lineHeight={"40px !important"}
            >
              Trending in Retail
            </Typography>
            <Divider></Divider>
          </Stack>
          <TabContext value={tabValue}>
            <Box
              sx={{
                width: "100%",
                paddingTop: "40px",
              }}
            >
              {isMobile ? (
                <TabList
                  onChange={handleCasestudyTab}
                  centered
                  variant="scrollable"
                  scrollButtons
                  allowScrollButtonsMobile
                  className="bordered-centertab"
                >
                  <Tab value="1" label="Case Studies" sx={{ fontSize: 18 }} />
                  <Tab value="2" label="Blogs" sx={{ fontSize: 18 }} />
                  <Tab value="3" label="Testimonials" sx={{ fontSize: 18 }} />
                </TabList>
              ) : (
                <TabList
                  onChange={handleCasestudyTab}
                  aria-label="scrollable force tabs example"
                  className="bordered-centertab"
                  centered
                >
                  <Tab
                    value="1"
                    label="Case Studies"
                    sx={{ fontSize: 18, border: "1px solid #A0A0A0" }}
                    title="Case Studies"
                  />
                  <Tab
                    value="2"
                    label="Blogs"
                    sx={{
                      fontSize: 18,
                      border: "1px solid #A0A0A0",
                      borderLeft: "none",
                      borderRight: "none",
                    }}
                    title="Blogs"
                  />
                  <Tab
                    value="3"
                    label="Testimonials"
                    sx={{ fontSize: 18, border: "1px solid #A0A0A0" }}
                    title="Testimonials"
                  />
                </TabList>
              )}
            </Box>
            <TabPanel value="1" sx={{ p: 0 }}>
              {isMobile ? (
                <Swiper
                  className="mySwiper swiper-container desktopView"
                  modules={[Autoplay, Pagination, Navigation]}
                  spaceBetween={14}
                  loop={true}
                  centeredSlides={true}
                  autoplay={{ delay: 3000 }}
                  navigation={false}
                  pagination={{
                    clickable: true,
                  }}
                >
                  <SwiperSlide className="slideWidth">
                    <Box
                      sx={{
                        position: "relative",
                        backgroundColor: "#fff",
                        px: isMobile ? 3 : 10,
                        py: 6,
                      }}
                      display="flex"
                      flexDirection={"column"}
                      justifyContent="space-between"
                      gap={3}
                    >
                      <Card
                        sx={{
                          borderRadius: 2.5,
                          width: isMobile ? "100%" : "33.33%",
                          border: "1px solid #A0A0A0",
                        }}
                      >
                        <CardActionArea
                          href="/invoicing-automation/"
                          sx={{ height: "100%" }}
                        >
                          <CardMedia
                            component="img"
                            height="140"
                            image={RetailCasestudy2}
                            alt="Cryptocurrency"
                            sx={{ objectPosition: "top", objectFit: "fill" }}
                          />
                          <CardContent
                            sx={{ textAlign: "center", minHeight: "6.5rem" }}
                          >
                            <Typography
                              gutterBottom
                              variant="h5"
                              fontSize={17}
                              fontWeight={700}
                              mb={0}
                              color="#333"
                              component="div"
                            >
                              Invoicing Automation
                            </Typography>
                          </CardContent>
                          <CardActions
                            sx={{ justifyContent: "center", pt: 0, pb: 1.5 }}
                          >
                            <Button
                              size="small"
                              sx={{
                                textDecoration: "underline",
                                textTransform: "Unset",
                                fontWeight: "700",
                              }}
                            >
                              Read more
                              <img src={arrowRight} alt="Arrow icon" />
                            </Button>
                          </CardActions>
                        </CardActionArea>
                      </Card>
                    </Box>
                  </SwiperSlide>
                  <SwiperSlide>
                    <Box
                      sx={{
                        position: "relative",
                        backgroundColor: "#fff",
                        px: isMobile ? 3 : 10,
                        py: 6,
                      }}
                      display="flex"
                      flexDirection={"column"}
                      justifyContent="space-between"
                      gap={3}
                    >
                      <Card
                        sx={{
                          borderRadius: 2.5,
                          width: isMobile ? "100%" : "33.33%",
                          border: "1px solid #A0A0A0",
                        }}
                      >
                        <CardActionArea
                          href="/building-resilient-infrastructure-for-seamless-customer-service-delivery/"
                          sx={{ height: "100%" }}
                        >
                          <CardMedia
                            component="img"
                            height="140"
                            image={RetailCasestudy3}
                            alt="Cryptocurrency"
                            sx={{ objectPosition: "top", objectFit: "fill" }}
                          />
                          <CardContent
                            sx={{ textAlign: "center", minHeight: "6.5rem" }}
                          >
                            <Typography
                              gutterBottom
                              variant="h5"
                              fontSize={17}
                              fontWeight={700}
                              mb={0}
                              color="#333"
                              component="div"
                            >
                              Building Resilient Infrastructure for Seamless
                              Customer Service Delivery
                            </Typography>
                          </CardContent>
                          <CardActions
                            sx={{ justifyContent: "center", pt: 0, pb: 1.5 }}
                          >
                            <Button
                              size="small"
                              sx={{
                                textDecoration: "underline",
                                textTransform: "Unset",
                                fontWeight: "700",
                              }}
                            >
                              Read more
                              <img src={arrowRight} alt="Arrow icon" />
                            </Button>
                          </CardActions>
                        </CardActionArea>
                      </Card>
                    </Box>
                  </SwiperSlide>
                  <SwiperSlide>
                    <Box
                      sx={{
                        position: "relative",
                        backgroundColor: "#fff",
                        px: isMobile ? 3 : 10,
                        py: 6,
                      }}
                      display="flex"
                      flexDirection={"column"}
                      justifyContent="space-between"
                      gap={3}
                    >
                      <Card
                        sx={{
                          borderRadius: 2.5,
                          width: isMobile ? "100%" : "33.33%",
                          border: "1px solid #A0A0A0",
                        }}
                      >
                        <CardActionArea
                          href="/rpa-shipping-automation/"
                          sx={{ height: "100%" }}
                        >
                          <CardMedia
                            component="img"
                            height="140"
                            image={RetailCasestudy1}
                            alt="Cryptocurrency"
                            sx={{ objectPosition: "top", objectFit: "fill" }}
                          />
                          <CardContent
                            sx={{ textAlign: "center", minHeight: "6.5rem" }}
                          >
                            <Typography
                              gutterBottom
                              variant="h5"
                              fontSize={17}
                              fontWeight={700}
                              mb={0}
                              color="#333"
                              component="div"
                            >
                              Shipping Label Automation
                            </Typography>
                          </CardContent>
                          <CardActions
                            sx={{ justifyContent: "center", pt: 0, pb: 1.5 }}
                          >
                            <Button
                              size="small"
                              sx={{
                                textDecoration: "underline",
                                textTransform: "Unset",
                                fontWeight: "700",
                              }}
                            >
                              Read more
                              <img src={arrowRight} alt="Arrow icon" />
                            </Button>
                          </CardActions>
                        </CardActionArea>
                      </Card>
                    </Box>
                  </SwiperSlide>
                </Swiper>
              ) : (
                <Swiper
                  className="mySwiper swiper-container desktopView"
                  modules={[Autoplay, Pagination, Navigation]}
                  spaceBetween={14}
                  loop={true}
                  centeredSlides={true}
                  autoplay={{ delay: 3000 }}
                  navigation={false}
                  pagination={{
                    clickable: true,
                  }}
                >
                  <SwiperSlide className="slideWidth">
                    <Box
                      sx={{
                        position: "relative",
                        backgroundColor: "#fff",
                        px: isMobile ? 3 : 10,
                        py: 6,
                      }}
                      display="flex"
                      flexDirection={isMobile ? "column" : "row"}
                      justifyContent="space-between"
                      gap={3}
                    >
                      <Card
                        sx={{
                          borderRadius: 2.5,
                          width: isMobile ? "100%" : "33.33%",
                          border: "1px solid #A0A0A0",
                        }}
                      >
                        <CardActionArea
                          href="/invoicing-automation/"
                          sx={{ height: "100%" }}
                        >
                          <CardMedia
                            component="img"
                            height="140"
                            image={RetailCasestudy2}
                            alt="Cryptocurrency"
                            sx={{ objectPosition: "top", objectFit: "fill" }}
                          />
                          <CardContent
                            sx={{ textAlign: "center", minHeight: "6.5rem" }}
                          >
                            <Typography
                              gutterBottom
                              variant="h5"
                              fontSize={17}
                              fontWeight={700}
                              mb={0}
                              color="#333"
                              component="div"
                            >
                              Invimatic empowered OTA to thrive streamlining
                              bookings and expand reach
                            </Typography>
                          </CardContent>
                          <CardActions
                            sx={{ justifyContent: "center", pt: 0, pb: 1.5 }}
                          >
                            <Button
                              size="small"
                              sx={{
                                textDecoration: "underline",
                                textTransform: "Unset",
                                fontWeight: "700",
                              }}
                            >
                              Read more
                              <img src={arrowRight} alt="Arrow icon" />
                            </Button>
                          </CardActions>
                        </CardActionArea>
                      </Card>
                      <Card
                        sx={{
                          borderRadius: 2.5,
                          width: isMobile ? "100%" : "33.33%",
                          border: "1px solid #A0A0A0",
                        }}
                      >
                        <CardActionArea
                          href="/building-resilient-infrastructure-for-seamless-customer-service-delivery/"
                          sx={{ height: "100%" }}
                        >
                          <CardMedia
                            component="img"
                            height="140"
                            image={RetailCasestudy3}
                            alt="Cryptocurrency"
                            sx={{ objectPosition: "top", objectFit: "fill" }}
                          />
                          <CardContent
                            sx={{ textAlign: "center", minHeight: "6.5rem" }}
                          >
                            <Typography
                              gutterBottom
                              variant="h5"
                              fontSize={17}
                              fontWeight={700}
                              mb={0}
                              color="#333"
                              component="div"
                            >
                              Building Resilient Infrastructure for Seamless
                              Customer Service Delivery
                            </Typography>
                          </CardContent>
                          <CardActions
                            sx={{ justifyContent: "center", pt: 0, pb: 1.5 }}
                          >
                            <Button
                              size="small"
                              sx={{
                                textDecoration: "underline",
                                textTransform: "Unset",
                                fontWeight: "700",
                              }}
                            >
                              Read more
                              <img src={arrowRight} alt="Arrow icon" />
                            </Button>
                          </CardActions>
                        </CardActionArea>
                      </Card>
                      <Card
                        sx={{
                          borderRadius: 2.5,
                          width: isMobile ? "100%" : "33.33%",
                          border: "1px solid #A0A0A0",
                        }}
                      >
                        <CardActionArea
                          href="/rpa-shipping-automation/"
                          sx={{ height: "100%" }}
                        >
                          <CardMedia
                            component="img"
                            height="140"
                            image={RetailCasestudy1}
                            alt="Cryptocurrency"
                            sx={{ objectPosition: "top", objectFit: "fill" }}
                          />
                          <CardContent
                            sx={{ textAlign: "center", minHeight: "6.5rem" }}
                          >
                            <Typography
                              gutterBottom
                              variant="h5"
                              fontSize={17}
                              fontWeight={700}
                              mb={0}
                              color="#333"
                              component="div"
                            >
                              Shipping Label Automation
                            </Typography>
                          </CardContent>
                          <CardActions
                            sx={{ justifyContent: "center", pt: 0, pb: 1.5 }}
                          >
                            <Button
                              size="small"
                              sx={{
                                textDecoration: "underline",
                                textTransform: "Unset",
                                fontWeight: "700",
                              }}
                            >
                              Read more
                              <img src={arrowRight} alt="Arrow icon" />
                            </Button>
                          </CardActions>
                        </CardActionArea>
                      </Card>
                    </Box>
                  </SwiperSlide>
                </Swiper>
              )}
            </TabPanel>
            <TabPanel value="2" sx={{ p: 0 }}>
              {isMobile ? (
                <Swiper
                  className="mySwiper swiper-container desktopView"
                  modules={[Autoplay, Pagination, Navigation]}
                  spaceBetween={14}
                  loop={true}
                  centeredSlides={true}
                  autoplay={{ delay: 3000 }}
                  navigation={false}
                  pagination={{
                    clickable: true,
                  }}
                >
                  <SwiperSlide className="slideWidth">
                    <Box
                      sx={{
                        position: "relative",
                        backgroundColor: "#fff",
                        px: isMobile ? 3 : 10,
                        py: 6,
                      }}
                      display="flex"
                      flexDirection={"column"}
                      justifyContent="space-between"
                      gap={3}
                    >
                      <Card
                        sx={{
                          borderRadius: 2.5,
                          width: isMobile ? "100%" : "33.33%",
                          border: "1px solid #A0A0A0",
                        }}
                      >
                        <CardActionArea
                          href="/blog/payment-gateway-integration/"
                          sx={{ height: "100%" }}
                        >
                          <CardMedia
                            component="img"
                            height="140"
                            image={Retailblog1}
                            alt="Cryptocurrency"
                            sx={{ objectPosition: "top", objectFit: "fill" }}
                          />
                          <CardContent
                            sx={{ textAlign: "center", minHeight: "6.5rem" }}
                          >
                            <Typography
                              gutterBottom
                              variant="h5"
                              fontSize={17}
                              fontWeight={700}
                              mb={0}
                              color="#333"
                              component="div"
                            >
                              Payment Gateway Integration- Everything You Need
                              To Know
                            </Typography>
                          </CardContent>
                          <CardActions
                            sx={{ justifyContent: "center", pt: 0, pb: 1.5 }}
                          >
                            <Button
                              size="small"
                              sx={{
                                textDecoration: "underline",
                                textTransform: "Unset",
                                fontWeight: "700",
                              }}
                            >
                              Read more
                              <img src={arrowRight} alt="Arrow icon" />
                            </Button>
                          </CardActions>
                        </CardActionArea>
                      </Card>
                    </Box>
                  </SwiperSlide>
                  <SwiperSlide>
                    <Box
                      sx={{
                        position: "relative",
                        backgroundColor: "#fff",
                        px: isMobile ? 3 : 10,
                        py: 6,
                      }}
                      display="flex"
                      flexDirection={"column"}
                      justifyContent="space-between"
                      gap={3}
                    >
                      <Card
                        sx={{
                          borderRadius: 2.5,
                          width: isMobile ? "100%" : "33.33%",
                          border: "1px solid #A0A0A0",
                        }}
                      >
                        <CardActionArea
                          href="/blog/rpa/all-hail-chatbots/"
                          sx={{ height: "100%" }}
                        >
                          <CardMedia
                            component="img"
                            height="140"
                            image={Retailblog2}
                            alt="Cryptocurrency"
                            sx={{ objectPosition: "top", objectFit: "fill" }}
                          />
                          <CardContent
                            sx={{ textAlign: "center", minHeight: "6.5rem" }}
                          >
                            <Typography
                              gutterBottom
                              variant="h5"
                              fontSize={17}
                              fontWeight={700}
                              mb={0}
                              color="#333"
                              component="div"
                            >
                              All Hail Chatbots!
                            </Typography>
                          </CardContent>
                          <CardActions
                            sx={{ justifyContent: "center", pt: 0, pb: 1.5 }}
                          >
                            <Button
                              size="small"
                              sx={{
                                textDecoration: "underline",
                                textTransform: "Unset",
                                fontWeight: "700",
                              }}
                            >
                              Read more
                              <img src={arrowRight} alt="Arrow icon" />
                            </Button>
                          </CardActions>
                        </CardActionArea>
                      </Card>
                    </Box>
                  </SwiperSlide>
                  <SwiperSlide>
                    <Box
                      sx={{
                        position: "relative",
                        backgroundColor: "#fff",
                        px: isMobile ? 3 : 10,
                        py: 6,
                      }}
                      display="flex"
                      flexDirection={"column"}
                      justifyContent="space-between"
                      gap={3}
                    >
                      <Card
                        sx={{
                          borderRadius: 2.5,
                          width: isMobile ? "100%" : "33.33%",
                          border: "1px solid #A0A0A0",
                        }}
                      >
                        <CardActionArea
                          href="blog/integration/third-party-integrations-to-enrich-your-app-development/"
                          sx={{ height: "100%" }}
                        >
                          <CardMedia
                            component="img"
                            height="140"
                            image={Retailblog3}
                            alt="Cryptocurrency"
                            sx={{ objectPosition: "top", objectFit: "fill" }}
                          />
                          <CardContent
                            sx={{ textAlign: "center", minHeight: "6.5rem" }}
                          >
                            <Typography
                              gutterBottom
                              variant="h5"
                              fontSize={17}
                              fontWeight={700}
                              mb={0}
                              color="#333"
                              component="div"
                            >
                              Third Party integrations to enrich your app
                              development!
                            </Typography>
                          </CardContent>
                          <CardActions
                            sx={{ justifyContent: "center", pt: 0, pb: 1.5 }}
                          >
                            <Button
                              size="small"
                              sx={{
                                textDecoration: "underline",
                                textTransform: "Unset",
                                fontWeight: "700",
                              }}
                            >
                              Read more
                              <img src={arrowRight} alt="Arrow icon" />
                            </Button>
                          </CardActions>
                        </CardActionArea>
                      </Card>
                    </Box>
                  </SwiperSlide>
                </Swiper>
              ) : (
                <Swiper
                  className="mySwiper swiper-container desktopView"
                  modules={[Autoplay, Pagination, Navigation]}
                  spaceBetween={14}
                  loop={true}
                  centeredSlides={true}
                  autoplay={{ delay: 3000 }}
                  navigation={false}
                  pagination={{
                    clickable: true,
                  }}
                >
                  <SwiperSlide className="slideWidth">
                    <Box
                      sx={{
                        position: "relative",
                        backgroundColor: "#fff",
                        px: isMobile ? 3 : 10,
                        py: 6,
                      }}
                      display="flex"
                      flexDirection={isMobile ? "column" : "row"}
                      justifyContent="space-between"
                      gap={3}
                    >
                      <Card
                        sx={{
                          borderRadius: 2.5,
                          width: isMobile ? "100%" : "33.33%",
                          border: "1px solid #A0A0A0",
                        }}
                      >
                        <CardActionArea
                          href="/blog/payment-gateway-integration/"
                          sx={{ height: "100%" }}
                        >
                          <CardMedia
                            component="img"
                            height="140"
                            image={Retailblog1}
                            alt="Cryptocurrency"
                            sx={{ objectPosition: "top", objectFit: "fill" }}
                          />
                          <CardContent
                            sx={{ textAlign: "center", minHeight: "6.5rem" }}
                          >
                            <Typography
                              gutterBottom
                              variant="h5"
                              fontSize={17}
                              fontWeight={700}
                              mb={0}
                              color="#333"
                              component="div"
                            >
                              Payment Gateway Integration- Everything You Need
                              To Know
                            </Typography>
                          </CardContent>
                          <CardActions
                            sx={{ justifyContent: "center", pt: 0, pb: 1.5 }}
                          >
                            <Button
                              size="small"
                              sx={{
                                textDecoration: "underline",
                                textTransform: "Unset",
                                fontWeight: "700",
                              }}
                            >
                              Read more
                              <img src={arrowRight} alt="Arrow icon" />
                            </Button>
                          </CardActions>
                        </CardActionArea>
                      </Card>
                      <Card
                        sx={{
                          borderRadius: 2.5,
                          width: isMobile ? "100%" : "33.33%",
                          border: "1px solid #A0A0A0",
                        }}
                      >
                        <CardActionArea
                          href="/blog/rpa/all-hail-chatbots/"
                          sx={{ height: "100%" }}
                        >
                          <CardMedia
                            component="img"
                            height="140"
                            image={Retailblog2}
                            alt="Cryptocurrency"
                            sx={{ objectPosition: "top", objectFit: "fill" }}
                          />
                          <CardContent
                            sx={{ textAlign: "center", minHeight: "6.5rem" }}
                          >
                            <Typography
                              gutterBottom
                              variant="h5"
                              fontSize={17}
                              fontWeight={700}
                              mb={0}
                              color="#333"
                              component="div"
                            >
                              All Hail Chatbots!
                            </Typography>
                          </CardContent>
                          <CardActions
                            sx={{ justifyContent: "center", pt: 0, pb: 1.5 }}
                          >
                            <Button
                              size="small"
                              sx={{
                                textDecoration: "underline",
                                textTransform: "Unset",
                                fontWeight: "700",
                              }}
                            >
                              Read more
                              <img src={arrowRight} alt="Arrow icon" />
                            </Button>
                          </CardActions>
                        </CardActionArea>
                      </Card>
                      <Card
                        sx={{
                          borderRadius: 2.5,
                          width: isMobile ? "100%" : "33.33%",
                          border: "1px solid #A0A0A0",
                        }}
                      >
                        <CardActionArea
                          href="/blog/integration/third-party-integrations-to-enrich-your-app-development/"
                          sx={{ height: "100%" }}
                        >
                          <CardMedia
                            component="img"
                            height="140"
                            image={Retailblog3}
                            alt="Cryptocurrency"
                            sx={{ objectPosition: "top", objectFit: "fill" }}
                          />
                          <CardContent
                            sx={{ textAlign: "center", minHeight: "6.5rem" }}
                          >
                            <Typography
                              gutterBottom
                              variant="h5"
                              fontSize={17}
                              fontWeight={700}
                              mb={0}
                              color="#333"
                              component="div"
                            >
                              Third Party integrations to enrich your app
                              development!
                            </Typography>
                          </CardContent>
                          <CardActions
                            sx={{ justifyContent: "center", pt: 0, pb: 1.5 }}
                          >
                            <Button
                              size="small"
                              sx={{
                                textDecoration: "underline",
                                textTransform: "Unset",
                                fontWeight: "700",
                              }}
                            >
                              Read more
                              <img src={arrowRight} alt="Arrow icon" />
                            </Button>
                          </CardActions>
                        </CardActionArea>
                      </Card>
                    </Box>
                  </SwiperSlide>
                </Swiper>
              )}
            </TabPanel>
            <TabPanel value="3" sx={{ p: 0 }}>
              {isMobile ? (
                <Container
                  className="mainWrapper positionReltive"
                  sx={style.mainWrapper}
                >
                  <Swiper
                    className="mySwiper navPaginationSwiper"
                    modules={[Autoplay, Pagination, Navigation]}
                    loop={true}
                    autoplay={{ delay: 3000 }}
                    centeredSlides={true}
                    pagination={{
                      clickable: true,
                    }}
                  >
                    <SwiperSlide className="slideWidth">
                      <Box
                        display="flex"
                        flexDirection="column"
                        sx={style.testimonialCard}
                        pt={5}
                        pr={5}
                        pb={4}
                        pl={4}
                      >
                        <Stack gap={2} direction="row" alignItems="center">
                          <Avatar
                            src={Will}
                            sx={{ height: 80, width: 80 }}
                          ></Avatar>
                          <Stack gap={0.8}>
                            <Typography
                              variant="h5"
                              fontWeight={700}
                              color="#170F49"
                              lineHeight="normal"
                            >
                              Will Marling
                            </Typography>
                            <Typography
                              color="#6F6C90"
                              lineHeight="normal"
                              fontSize={13}
                            >
                              COO and VP for SE Implementation Services,
                              ShuffleLabs
                            </Typography>
                          </Stack>
                        </Stack>
                        <Box mt={2} mb={2} sx={style.wordingsBlock}>
                          <Typography
                            variant="body1"
                            fontSize={15}
                            color="#514F6E"
                          >
                            "Invimatic Solutions is a great partner for
                            development needs. Their skilled team provides
                            cost-effective solutions and meaningful support for
                            complex projects."
                          </Typography>
                        </Box>
                      </Box>
                    </SwiperSlide>
                    <SwiperSlide className="slideWidth">
                      <Box
                        display="flex"
                        flexDirection="column"
                        sx={style.testimonialCard}
                        mx="auto"
                        pt={5}
                        pr={5}
                        pb={4}
                        pl={4}
                      >
                        <Stack gap={2} direction="row" alignItems="center">
                          <Avatar
                            src={aaron}
                            sx={{ height: 80, width: 80 }}
                          ></Avatar>
                          <Stack gap={0.8}>
                            <Typography
                              variant="h5"
                              fontWeight={700}
                              color="#170F49"
                              lineHeight="normal"
                            >
                              Aaron Dix
                            </Typography>
                            <Typography
                              color="#6F6C90"
                              lineHeight="normal"
                              fontSize={13}
                            >
                              Founder & CEO, BettrData.io
                            </Typography>
                          </Stack>
                        </Stack>
                        <Box mt={2} mb={2} sx={style.wordingsBlock}>
                          <Typography variant="body1" fontSize={15}>
                            "Invimatic was crucial to our startup's success.
                            They delivered high-quality work on tight deadlines
                            and kept us informed with clear communication."
                          </Typography>
                        </Box>
                      </Box>
                    </SwiperSlide>
                    <SwiperSlide className="slideWidth">
                      <Box
                        display="flex"
                        flexDirection="column"
                        sx={style.testimonialCard}
                        mx="auto"
                        pt={5}
                        pr={5}
                        pb={4}
                        pl={4}
                      >
                        <Stack gap={2} direction="row" alignItems="center">
                          <Avatar
                            src={cleve}
                            sx={{ height: 80, width: 80 }}
                          ></Avatar>
                          <Stack gap={0.8}>
                            <Typography
                              variant="h5"
                              fontWeight={700}
                              color="#170F49"
                              lineHeight="normal"
                            >
                              Clive Vaz
                            </Typography>
                            <Typography
                              color="#6F6C90"
                              lineHeight="normal"
                              fontSize={13}
                            >
                              Technology consulting & advisory, PeepsRide
                            </Typography>
                          </Stack>
                        </Stack>
                        <Box mt={2} mb={2} sx={style.wordingsBlock}>
                          <Typography variant="body1" fontSize={15}>
                            "Working with Invimatic's team, led by Raghava and
                            Prashant, was a privilege. They exceeded our
                            expectations with their expertise and timely
                            delivery."
                          </Typography>
                        </Box>
                      </Box>
                    </SwiperSlide>
                  </Swiper>
                </Container>
              ) : (
                <Box className="successStoryBox">
                  <Swiper
                    // className="mySwiper navPaginationSwiper"
                    className="mySwiper swiper-container desktopView "
                    // breakpoints={{
                    //   601: {
                    //     slidesPerView: 1.5,
                    //     spaceBetween: 14,
                    //   },
                    //   1024: {
                    //     slidesPerView: 2.1,

                    //   }
                    // }}
                    modules={[Autoplay, Pagination, Navigation]}
                    spaceBetween={14}
                    loop={true}
                    centeredSlides={true}
                    autoplay={{ delay: 6000 }}
                    navigation={true}
                  >
                    <SwiperSlide className="slideWidth">
                      <Box
                        display="flex"
                        flexDirection="row"
                        mx="auto"
                        gap={3}
                        pt={5}
                        pr={"55px"}
                        pb={4}
                        pl={"55px"}
                      >
                        <Card sx={style.testimonialCard}>
                          <Stack gap={2} direction="row" alignItems="center">
                            <Avatar
                              src={cleve}
                              sx={{ height: 80, width: 80 }}
                            ></Avatar>
                            <Stack gap={0.8}>
                              <Typography
                                variant="h5"
                                fontWeight={700}
                                color="#170F49"
                                lineHeight="normal"
                              >
                                Clive Vaz
                              </Typography>
                              <Typography
                                color="#6F6C90"
                                lineHeight="normal"
                                fontSize={13}
                              >
                                Technology consulting & advisory, PeepsRide
                              </Typography>
                            </Stack>
                          </Stack>
                          <Box mt={2} mb={2} sx={style.wordingsBlock}>
                            <Typography variant="body1" fontSize={15}>
                              "Working with Invimatic's team, led by Raghava and
                              Prashant, was a privilege. They exceeded our
                              expectations with their expertise and timely
                              delivery."
                            </Typography>
                          </Box>
                        </Card>
                        <Card sx={style.testimonialCard}>
                          <Stack gap={2} direction="row" alignItems="center">
                            <Avatar
                              src={aaron}
                              sx={{ height: 80, width: 80 }}
                            ></Avatar>
                            <Stack gap={0.8}>
                              <Typography
                                variant="h5"
                                fontWeight={700}
                                color="#170F49"
                                lineHeight="normal"
                              >
                                Aaron Dix
                              </Typography>
                              <Typography
                                color="#6F6C90"
                                lineHeight="normal"
                                fontSize={13}
                              >
                                Founder & CEO, BettrData.io
                              </Typography>
                            </Stack>
                          </Stack>
                          <Box mt={2} mb={2} sx={style.wordingsBlock}>
                            <Typography variant="body1" fontSize={15}>
                              "Invimatic was crucial to our startup's success.
                              They delivered high-quality work on tight
                              deadlines and kept us informed with clear
                              communication."
                            </Typography>
                          </Box>
                        </Card>
                        <Card sx={style.testimonialCard}>
                          <Stack gap={2} direction="row" alignItems="center">
                            <Avatar
                              src={Will}
                              sx={{ height: 80, width: 80 }}
                            ></Avatar>
                            <Stack gap={0.8}>
                              <Typography
                                variant="h5"
                                fontWeight={700}
                                color="#170F49"
                                lineHeight="normal"
                              >
                                Will Marling
                              </Typography>
                              <Typography
                                color="#6F6C90"
                                lineHeight="normal"
                                fontSize={13}
                              >
                                COO and VP for SE Implementation Services,
                                ShuffleLabs
                              </Typography>
                            </Stack>
                          </Stack>
                          <Box mt={2} mb={2} sx={style.wordingsBlock}>
                            <Typography
                              variant="body1"
                              fontSize={15}
                              color="#514F6E"
                            >
                              "Invimatic Solutions is a great partner for
                              development needs. Their skilled team provides
                              cost-effective solutions and meaningful support
                              for complex projects."
                            </Typography>
                          </Box>
                        </Card>
                      </Box>
                    </SwiperSlide>
                  </Swiper>
                </Box>
              )}
            </TabPanel>
          </TabContext>
        </Box>
      </section>

      <section className="discussYourProject">
        <Container maxWidth="lg">
          <Stack
            sx={{
              position: "relative",
              zIndex: 1,
              pt: isMobile ? 0 : 5,
              pb: 0,
            }}
            direction={isMobile ? "column" : "row"}
            alignItems="center"
          >
            <Stack
              alignItems="center"
              gap={5}
              sx={{ width: isMobile ? "100%" : "50%" }}
            >
              <Stack alignItems="center" textAlign="center" gap={2}>
                <img
                  src={chatIcon}
                  alt="Chat icon"
                  style={{ width: "auto !important" }}
                />
                <Typography
                  variant="body1"
                  fontWeight={600}
                  color="#C8DCFA"
                  textAlign="center"
                >
                  Let's discuss your project
                </Typography>
                <Typography
                  variant="h4"
                  color="#fff"
                  fontSize="20px"
                  fontWeight={700}
                  lineHeight="28px"
                  padding="0 30px"
                >
                  Looking to scale your SaaS effortlessly? <br/>
                  Share your project details, and we'll provide tailored solutions to support the growth and security of your SaaS business.
                </Typography>
              </Stack>
            </Stack>
            <Box
              sx={{
                width: isMobile ? "100%" : "50%",
                marginTop: isMobile ? "20px" : "0px",
              }}
            >
              <Enquiry />
            </Box>
          </Stack>
        </Container>
      </section>
    </Layout>
  )
}

export default OmnichannelEcommerceSolution
